"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMarkStaffNotificationAsReadMutation = exports.useLazyGetNotificationsByStaffMemberIdAllQuery = exports.useLazyGetNotificationsByStaffMemberIdQuery = exports.useGetNotificationsByStaffMemberIdQuery = exports.useGetNotificationsSeveritiesQuery = exports.useGetNotificationsProgrammeesQuery = exports.useGetNotificationsPublieesQuery = exports.useDuplicateNotificationMutation = exports.useDeleteNotificationMutation = exports.useUnArchiveNotificationMutation = exports.useArchiveNotificationMutation = exports.useLazyNotificationByIdQuery = exports.useGetNotificationsQuery = exports.useAddOrUpdateNotificationMutation = exports.NotificationApi = exports.prepareHeaders = void 0;
const react_1 = require("@reduxjs/toolkit/query/react");
const http_1 = require("../../http");
const storage_1 = require("../../storage");
const Utils_1 = require("../../Utils");
const prepareHeaders = (headers, { getState }) => {
    var _a, _b;
    const token = (_a = getState().user.token) !== null && _a !== void 0 ? _a : (_b = storage_1.AppStorage.getItem("user")) === null || _b === void 0 ? void 0 : _b.token;
    if (token) {
        headers.set("Authorization", `Bearer ${token}`);
    }
    return headers;
};
exports.prepareHeaders = prepareHeaders;
exports.NotificationApi = (0, react_1.createApi)({
    reducerPath: "notificationApi",
    tagTypes: ["notification", "notificationList", "notificationById"],
    baseQuery: (0, react_1.fetchBaseQuery)({
        baseUrl: `${http_1.ApiBaseUrl}`,
        prepareHeaders: exports.prepareHeaders,
    }),
    endpoints: (builder) => ({
        addOrUpdateNotification: builder.mutation({
            invalidatesTags: [
                "notification",
                "notificationList",
                "notificationById",
            ],
            query: ({ id, data }) => {
                if (id) {
                    return {
                        url: `notifications/${id}/`,
                        method: "POST",
                        body: data,
                    };
                }
                return {
                    url: `notifications/`,
                    method: "POST",
                    body: data,
                };
            },
        }),
        getNotifications: builder.query({
            providesTags: ["notificationList"],
            query: (query) => (0, Utils_1.QueryUrl)("notifications", query),
        }),
        getNotificationsPubliees: builder.query({
            providesTags: ["notificationList"],
            query: (query) => (0, Utils_1.QueryUrl)("publish-notifications", query),
        }),
        getNotificationsProgrammees: builder.query({
            providesTags: ["notificationList"],
            query: (query) => (0, Utils_1.QueryUrl)("schedul-notifications", query),
        }),
        getNotificationsSeverities: builder.query({
            providesTags: ["notificationList"],
            query: (query) => (0, Utils_1.QueryUrl)("notification-severities", query),
        }),
        notificationById: builder.query({
            query: (id) => `notifications/${id}/`,
            providesTags: ["notificationById"],
        }),
        duplicateNotification: builder.mutation({
            query: (id) => ({
                url: `/duplicate/notification/${id}/`,
                method: "POST",
                // body: data,
            }),
            invalidatesTags: [
                "notification",
                "notificationList",
                "notificationById",
            ],
        }),
        archiveNotification: builder.mutation({
            query: (id) => ({
                url: `notifications/${id}/`,
                method: "GET",
            }),
            invalidatesTags: [
                "notification",
                "notificationList",
                "notificationById",
            ],
        }),
        unArchiveNotification: builder.mutation({
            query: (id) => ({
                url: `reactive_notifications/${id}/`,
                method: "GET",
            }),
            invalidatesTags: [
                "notification",
                "notificationList",
                "notificationById",
            ],
        }),
        deleteNotification: builder.mutation({
            query: (id) => ({
                url: `notifications/${id}/`,
                method: "DELETE",
            }),
            invalidatesTags: [
                "notification",
                "notificationList",
                "notificationById",
            ],
        }),
        getNotificationsByStaffMemberId: builder.query({
            providesTags: [
                "notification",
                "notificationList",
                "notificationById",
            ],
            query: ({ user_id, query }) => (0, Utils_1.QueryUrl)(`getNotificationsByStaffMemberId/${user_id}`, query),
        }),
        getNotificationsByStaffMemberIdAll: builder.query({
            providesTags: [
                "notification",
                "notificationList",
                "notificationById",
            ],
            query: ({ user_id, query }) => (0, Utils_1.QueryUrl)(`getNotificationsByStaffMemberId/${user_id}?no_pagination=1`, query),
            transformResponse: (response) => {
                var _a;
                // 🔹 Certains backend renvoient { data: [...] } ou { success, data }
                // On normalise ici pour que la réponse soit toujours un tableau
                if (Array.isArray(response))
                    return response;
                if (Array.isArray(response === null || response === void 0 ? void 0 : response.data))
                    return response.data;
                if (Array.isArray((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.data))
                    return response.data.data;
                return [];
            },
        }),
        markStaffNotificationAsRead: builder.mutation({
            query: (id) => ({
                url: `setMyNotificationIsRead/${id}`, // adapte au vrai endpoint
                method: "GET",
            }),
            invalidatesTags: ["notification", "notificationList", "notificationById"],
        }),
    }),
});
exports.useAddOrUpdateNotificationMutation = exports.NotificationApi.useAddOrUpdateNotificationMutation, exports.useGetNotificationsQuery = exports.NotificationApi.useGetNotificationsQuery, exports.useLazyNotificationByIdQuery = exports.NotificationApi.useLazyNotificationByIdQuery, exports.useArchiveNotificationMutation = exports.NotificationApi.useArchiveNotificationMutation, exports.useUnArchiveNotificationMutation = exports.NotificationApi.useUnArchiveNotificationMutation, exports.useDeleteNotificationMutation = exports.NotificationApi.useDeleteNotificationMutation, exports.useDuplicateNotificationMutation = exports.NotificationApi.useDuplicateNotificationMutation, exports.useGetNotificationsPublieesQuery = exports.NotificationApi.useGetNotificationsPublieesQuery, exports.useGetNotificationsProgrammeesQuery = exports.NotificationApi.useGetNotificationsProgrammeesQuery, exports.useGetNotificationsSeveritiesQuery = exports.NotificationApi.useGetNotificationsSeveritiesQuery, exports.useGetNotificationsByStaffMemberIdQuery = exports.NotificationApi.useGetNotificationsByStaffMemberIdQuery, exports.useLazyGetNotificationsByStaffMemberIdQuery = exports.NotificationApi.useLazyGetNotificationsByStaffMemberIdQuery, exports.useLazyGetNotificationsByStaffMemberIdAllQuery = exports.NotificationApi.useLazyGetNotificationsByStaffMemberIdAllQuery, exports.useMarkStaffNotificationAsReadMutation = exports.NotificationApi.useMarkStaffNotificationAsReadMutation;
